<template>
	<c-dialog ref="dialog" title="数据看板指标" width="850" height="550" @resolve="submitHandle">
		<div class="metric-config">
			<section v-for="group in metricGroups" :key="group.key" class="metric-group">
				<h3 class="group-title">{{group.name}}</h3>
				<div class="group-columns">
					<dl>
						<dt class="flex-between-center"><p>已选项</p><span>拖动可调整组内顺序</span></dt>
						<dd>
							<c-drag-sort v-model="groupSelected[group.key]" class="metric-list flex-wrap">
								<template #default="{item, id, index}">
									<c-drag-item :key="id" class="metric-item flex-center-cross z-selected">
										<p class="ellipsis flex-grow">{{item.name}}</p>
										<a @click="removeMetric(group.key, index)"><i class="c-icon-cross"></i></a>
									</c-drag-item>
								</template>
							</c-drag-sort>
							<p v-if="!groupSelected[group.key].length" class="empty-tip">暂无已选指标</p>
						</dd>
					</dl>
					<dl>
						<dt class="flex-between-center"><p>待选项</p><span>点击添加到已选列表</span></dt>
						<dd>
							<ul class="metric-list flex-wrap">
								<li v-for="item in groupAvailable[group.key]" :key="item.code" class="metric-item flex-center-cross" @click="addMetric(group.key, item)"><p class="ellipsis">{{item.name}}</p></li>
							</ul>
							<p v-if="!groupAvailable[group.key].length" class="empty-tip">暂无待选指标</p>
						</dd>
					</dl>
				</div>
			</section>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				realtimeCodes: ['payable_amount', 'receivable_amount', 'stock_quantity', 'transferring_quantity', 'lend_count'],
				metricGroups: [{key: 'realtime', name: '实时统计'}, {key: 'dated', name: '日期统计'}],
				groupSelected: {realtime: [], dated: []},
				groupAvailable: {realtime: [], dated: []}
			}
		},
		methods: {
			open() {
				this.$refs.dialog.open();
				this.request({
					url: '/workbench/board/config', data: {},
					success: data => {
						const selectedList = data.selected_list || [];
						const availableList = data.available_list || [];
						this.metricGroups.forEach(group => {
							const inGroup = item => this.realtimeCodes.includes(item.code) === (group.key === 'realtime');
							this.groupSelected[group.key] = selectedList.filter(inGroup);
							this.groupAvailable[group.key] = availableList.filter(inGroup);
						});
					}
				});
			},
			removeMetric(group, index) {
				this.groupAvailable[group].push(this.groupSelected[group].splice(index, 1)[0]);
			},
			addMetric(group, item) {
				this.groupSelected[group].push(item);
				this.groupAvailable[group] = this.groupAvailable[group].filter(metric => metric.code !== item.code);
			},
			submitHandle(stop, next) {
				stop();
				const metricCodes = this.groupSelected.realtime.concat(this.groupSelected.dated).map(item => item.code).join(',');
				if (!metricCodes) {
					this.$message({message: '请至少配置一项指标', type: 'warn'});
					return;
				}
				this.request({
					url: '/workbench/board/config/edit', data: {metric_codes: metricCodes}, loading: true,
					success: () => {
						next();
						this.$message({message: '保存成功'});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.metric-config {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .metric-group {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        & + .metric-group {
            border-top: 1px solid #e8eaf0;
        }
    }
    .group-title {
        margin: 0;
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
    }
    .group-columns {
        display: flex;
        flex: 1;
        min-height: 0;
    }
    dl {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        & + dl {
            border-left: 1px solid #e8eaf0;
        }
    }
    .empty-tip {
        font-size: 12px;
        color: #999;
        padding: 8px 0;
    }
	dt {
        height: 36px;
        flex-shrink: 0;
        padding: 0 12px 0 16px;
        background: #FAFAFA;
        span {
            font-size: 12px;
            color: #666;
        }
    }
	dd {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding: 12px 14px;
    }
	.metric-list {
        gap: 10px;
    }
	.metric-item {
        box-sizing: border-box;
		width: calc((100% - 20px) / 3);
        height: 35px;
        padding: 0 8px 0 12px;
        font-size: 13px;
        background: #F5F5F5;
        cursor: pointer;
        &:not(.z-selected):hover {
            color: #fff;
            background: var(--color-main);
        }
        &.z-selected {
            color: var(--color-main);
            background: #eef2ff;
            a {
                padding: 4px;
				color: #999;
                &:hover {
                    color: #FF414A;
                }
            }
        }

    }

</style>
